export default __webpack_public_path__ + "static/media/10.d8889d2f.png";